export default __webpack_public_path__ + "static/media/audience-placeholder.e37fef11.png";